// Project优先级
export enum ProjectPriority {
  S = 11,
  A = 22,
  B = 33,
  C = 44,
  Z = 99,
}

// Project详情页Technical模块
export enum ProjectTechnicalModule {
  Engine = 'engine',
  ServerProvider = 'server',
  ProgrammingLanguage = 'language',
  DatabaseAndDataService = 'database',
  AntiCheatSolution = 'anti_cheat',
  VersionControlSystem = 'version_control',
}
